<template>
<div class="chapter">
<div class="inner_page">
<p class="tx" id="d7e372a"><br/></p>
<p class="legalnotice" id="d7e372">© 1982 by Jack Van Impe Ministries.</p>
<p class="biblioid" id="d7e532">Published in Nashville, Tennessee, by Thomas Nelson. Thomas Nelson is a registered trademark of Thomas Nelson, Inc.</p>
<p class="legalnotice" id="d7e632">Thomas Nelson, Inc. titles may be purchased in bulk for educational, business, fund-raising, or sales promotional use. For information, please e-mail SpecialMarkets@ThomasNelson.com.</p>
<p class="legalnotice" id="d7e802">All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher. </p>
<p class="printhistoryl" id="d7e1042">Printed in the United States.<br/>Revised edition, 1992<br/> Second printing, 1993<br/> Third printing, 1994<br/> Fourth printing, 1994 <br/>Fifth printing, 1994 <br/>Sixth printing, 1995<br/> Seventh printing, 1996<br/> Eighth printing, 1996 </p>
<p class="legalnotice" id="d7e1532">All Scripture quotations are from the King James Version of the Bible.</p>
<p class="tx" id="d7e372b"><br/></p>
<p class="legalnotice" id="d7e1602">For a complete list of recordings, books, and other resource materials by Dr. Jack Van Impe, write for our latest catalog:</p>
<p class="legalnoticec" id="d7e1722">JACK VAN IMPE MINISTRIES<br/> P. O. Box 7004 • Troy, Michigan 48997<br/> In Canada: Box 1717, Postal Station A <br/>Windsor, Ontario N9A 6Y1 </p>
<p class="isbn" id="d7e2102">ISBN 978-0-8499-3964-8 </p>
<p class="printhistory" id="d7e2212"><i>Printed in the United States of America </i></p>
<p class="other" id="d7e221122">08 09 10 11 12 QW 20 19 18 17 16 </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Impe_ISBN9781418517243_epub_c2_r1.vue?b8830c06